import { Constants } from "../lib/constants";
import { StringHelper } from ".";
import { IAppConfig } from "../settings";

export namespace ApplicationHelper {
    export const BaseUrl = (): string => {
        var result: string = process.env?.PUBLIC_URL;

        if (StringHelper.isNullOrEmpty(result)) {
            result = window.location.origin;
        }

        result = window.location.origin;
        return result;
    }

    export const GetBasename = () => {
        var publicUrl = process.env?.PUBLIC_URL;
        if (StringHelper.isNullOrEmpty(publicUrl)) {
            return Constants.emptyString;
        }

        return GetBasePath(window.location.pathname);
    }

    export const GetBasePath = (path: string): string => {
        if (StringHelper.isNullOrEmpty(path)) {
            return Constants.emptyString;
        }

        return path.substring(0, path.lastIndexOf('/'));
    }

    export async function LoadConfig(): Promise<IAppConfig> {
        const response = await fetch('/settings.json');

        if (!response.ok) {
            throw new Error(`Failed to load config: ${response.status}`);
        }

        return response.json() as Promise<IAppConfig>;
    }
}